import { Component, Input, OnInit } from '@angular/core';
import {
  getFadeInTransition,
  getFadeOutTransition,
} from '../../../../../../../../../../core/pure-functions/animations/ng-animations-provider';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { BehaviorSubject } from 'rxjs';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';

@Component({
  selector: 'app-products-charter-duration',
  templateUrl: './products-charter-duration.component.html',
  styleUrls: ['./products-charter-duration.component.scss'],
  animations: [getFadeInTransition(1000), getFadeOutTransition(1000)],
})
export class ProductsCharterDurationComponent implements OnInit {
  @Input() resetEditState;
  @Input() productOffering: BehaviorSubject<Partial<ProductOffering>>;

  model: Vessel;
  halfDay: boolean;
  fullDay: boolean;
  duration: number;

  constructor() {}

  ngOnInit() {
    if (this.productOffering.value.duration) {
      this.duration = this.productOffering.value.duration;
    }
  }

  selectDuration() {
    if (this.duration) {
      this.productOffering.next({
        ...this.productOffering.value,
        duration: Number(this.duration),
      });
    }
  }
}
